import type {
  CreateMachineProductRequest,
  MachineProductEntity,
} from "../../domain/types/machine-product";
import { MachineProductEntitySchema } from "../../domain/types/machine-product";
import type { MachineProductRepository } from "../../domain/repositories/machine-product-repository";
import { machineProductApiService } from "../api/machine-product-api-service";

export class MachineProductRepositoryImpl implements MachineProductRepository {
  async createMachineProduct(
    request: CreateMachineProductRequest,
  ): Promise<MachineProductEntity> {
    const response = await machineProductApiService.createMachineProduct(request);

    if (response.data) {
      return MachineProductEntitySchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "machine product 가져오기 실패.");
  }

  async searchMachineProduct(machineId: number): Promise<MachineProductEntity[]> {
    const response = await machineProductApiService.searchMachineProduct(machineId);

    if (response.data) {
      return response.data.map(product => MachineProductEntitySchema.parse(product));
    }

    throw new Error(response.errorMsg || "machine product 검색 실패.");
  }
}